import { render, staticRenderFns } from "./file-card.vue?vue&type=template&id=5c25ed8c&scoped=true&"
import script from "./file-card.vue?vue&type=script&lang=js&"
export * from "./file-card.vue?vue&type=script&lang=js&"
import style0 from "./file-card.vue?vue&type=style&index=0&id=5c25ed8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c25ed8c",
  null
  
)

export default component.exports